module.exports = __webpack_public_path__ + "assets/img/img-12.6146abce.png";